import { render, staticRenderFns } from "./preview-asset-gallery.vue?vue&type=template&id=33823fee&scoped=true&"
import script from "./preview-asset-gallery.vue?vue&type=script&lang=ts&"
export * from "./preview-asset-gallery.vue?vue&type=script&lang=ts&"
import style0 from "./preview-asset-gallery.vue?vue&type=style&index=0&id=33823fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33823fee",
  null
  
)

export default component.exports